import { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
// import momentLocalizer from "react-widgets-moment";

// new momentLocalizer(moment);

export default function ModalFormDesinstalacion({ title, formData, setFormData, isOpen, onCancel, onConfirm }) {

    const { t } = useTranslation();
    const dateInputRef = useRef(null);

    const [fechaDesinstalacion, setFechaDesinstalacion] = useState("");

    // useEffect(() => {
    //     const userDate = moment().format("YYYY/MM/DD"); // Get user date in YYYY/MM/DD
    //     setFechaDesinstalacion(userDate);
    // }, []);

    useEffect(() => {
        // iniciar();
    }, [formData]);

    // const iniciar = async () => {
    //     try {
    //         // console.log('formData');
    //         // console.log(formData);
    //     } catch (err) {
    //         console.log('iniciar err');
    //         console.log(err);
    //     }
    // };

    const charLimits = {
        numeroOrdenDesinstalacion: 128,
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const validateForm = () => {
        try {
            // console.log('validateForm');
            // console.log(formData);
            // console.log("proveedorSelected", proveedorSelected);
            let message = "";
            if (moment(fechaDesinstalacion).isValid() === false) {
                message = message + t("alert_invalid_date") + '\n';
            }
            if (String(formData.numeroOrdenDesinstalacion).trim().length === 0) {
                message = message + "Debe ingresar Numero Orden Desinstalacion" + '\n';
            }

            if (message.length > 0) {
                alert(message);
                return;
            }
            formData.fechaDesinstalacion = moment(fechaDesinstalacion).format("YYYY/MM/DD");
            // console.log('formData');
            // console.log(formData);
            onConfirm(formData);
        } catch (err) {
            console.log('validateForm err');
            console.log(err);
        }
    };

    const cancelForm = () => {
        setFormData({
            ...formData,
            id: 0,
            fechaDesinstalacion: "",
            numeroOrdenDesinstalacion: "",
        });
        setFechaDesinstalacion("");
        onCancel();
    }

    return (
        <>
            {isOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-1/3">
                        <h2 className="text-xl font-bold mb-4 text-gray-700">{title}</h2>

                        {/* Inputs */}
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_date_unistall")}: MM/DD/YYYY<span className="text-red-500">*</span></label>
                            <div
                                className="relative w-full cursor-pointer"
                                onClick={() => dateInputRef.current?.showPicker()} // Open calendar on click
                            >
                                <input
                                    type="date"
                                    ref={dateInputRef}
                                    value={fechaDesinstalacion}
                                    onChange={(e) => {
                                        // console.log('date:', e.target.value);
                                        setFechaDesinstalacion(e.target.value);
                                    }}
                                    className="w-full px-3 py-2 border border-gray-300 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                />
                            </div>
                        </div>
                        <div className="mb-4">
                            <label className="block text-gray-600 font-semibold mb-1">{t("label_order_number_uninstall")}<span className="text-red-500">*</span></label>
                            <input
                                name="numeroOrdenDesinstalacion"
                                value={formData.numeroOrdenDesinstalacion}
                                onChange={handleInputChange}
                                placeholder={t("enter_order_number")}
                                className="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
                            />
                            <p className="text-sm text-gray-500 flex justify-end">{formData.numeroOrdenDesinstalacion.length}/{charLimits.numeroOrdenDesinstalacion}</p>
                        </div>

                        {/* Buttons */}
                        <div className="flex justify-end gap-4">
                            <button
                                onClick={cancelForm}
                                className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500 transition duration-300"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={validateForm}
                                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 transition duration-300"
                            >
                                Acceptar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );

}
